module.exports = "/assets/data/0e300447a231a9e0c73f3ce8531c2f50-ST17.data.json";